import { SettingsFeatureEndpoint } from '@core/types/types.endpoint.settings';
import { Features } from '@core/types/types.features';
import { Switch } from '@frontend/components/ui/switch';
import { useDirectoryUpdater } from '@frontend/shared/hooks/shared.hook.useDirectoryUpdater';
import { useFlag } from '@frontend/shared/hooks/shared.hook.useFlag';
import { useSubmitter } from '@frontend/shared/hooks/useSubmitter';
import { callApi } from '@frontend/shared/util/util.callApi';

export interface SettingsFeatureFlag {
  title: string;
  description: string;
  learnMore?: string;
  feature: Features;
  isReadOnly?: boolean;
}

export function SettingsFeatureFlag({
  title,
  description,
  learnMore,
  feature,
  isReadOnly = false,
}: SettingsFeatureFlag) {
  const updater = useDirectoryUpdater();

  const isChecked = useFlag(feature);
  const submitter = useSubmitter(async () => {
    const [, res] = await callApi<SettingsFeatureEndpoint>(
      `/settings/feature`,
      {
        feature,
        enabled: !isChecked,
      },
    );
    if (res) {
      updater({
        team: res,
      });
    }
  });
  return (
    <div className="flex items-center">
      <div>
        <h3 className="text-xs font-semibold">{title}</h3>

        <p className="mt-1 text-xs font-medium text-gray-500">
          {description}
          {learnMore && (
            <a
              className="ml-1 cursor-pointer text-xs font-bold text-blue-600 hover:underline"
              target="_blank"
              rel="noopener noreferrer"
              href={learnMore}
            >
              Learn more
            </a>
          )}
        </p>
      </div>
      <Switch
        className="ml-auto"
        disabled={submitter.isSubmitting || isReadOnly}
        checked={isChecked}
        onCheckedChange={() => {
          if (!isReadOnly) {
            submitter.submit();
          }
        }}
      />
    </div>
  );
}
